import { Alert, Anchor, Text, TextButton } from '@zillow/constellation-10';
import StringConstants from '@common/constants/StringConstants';

interface Props {
  isDashboard?: boolean;
}

const getErrorMessage = (isDashboard: boolean): string => {
  if (!isDashboard) {
    return `It looks like there's a problem setting up payments. Please contact customer service.`;
  } else {
    return `Looks like there's an issue with your account information. Please contact customer service.`;
  }
};

export const LandlordBlockCard = ({ isDashboard }: Props) => {
  const supportEmail = StringConstants.LINKS.SUPPORT_EMAIL.zillow;
  const errorMessage = getErrorMessage(isDashboard === undefined ? true : isDashboard);

  return (
    <Alert
      css={{ padding: 'default', marginBottom: 'loose' }}
      tone="critical"
      actionButton={
        <TextButton asChild>
          <Anchor href={`mailto:${supportEmail}`}>Email us</Anchor>
        </TextButton>
      }
    >
      <Text>{errorMessage}</Text>
    </Alert>
  );
};
